module.exports = __webpack_public_path__ + "static/media/fish_back.4f42c106.jpg";